import styled, { css } from 'styled-components';

import Button from '../_Button';
import Loader from '../../loader/Loader';
import media from '../../../utils/styling/media';

interface StyledButtonProps {
  busy?: boolean;
  reversed?: boolean;
  fullWidth?: boolean;
  isPhoneSize?: boolean;
  $wrap?: boolean;
}

export const StyledButton = styled(Button)<StyledButtonProps>`
  height: ${({ $wrap }) => $wrap ? 'auto' : '50px'};
  font-size: 17px;
  font-weight: ${({ theme }) => theme?.PrimaryButton?.fontWeight};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme, busy }) => busy ? 'transparent' : theme.colors.white};
  padding: ${({ $wrap }) => $wrap ? '12px ' : '0 '} 32px;
  border-radius: ${({ theme }) => theme?.PrimaryButton?.borderRadius || theme?.Button?.borderRadius};
  box-shadow: ${({ theme }) => theme?.PrimaryButton?.boxShadow};
  line-height: ${({ $wrap }) => $wrap ? 'inherit' : '50px'};

  ${({ reversed }) => !reversed && css<StyledButtonProps>`
    &:hover {
      background: ${({ theme }) => theme.colors.light};
    }

    &[disabled], &:disabled {
      background: ${({ theme }) => theme.colors.disabled};
      font-style: ${({ busy, theme }) => busy ? 'normal' : theme?.Button?.disabledFontStyle};
      cursor: default;
    }

    &:focus-visible, &:focus {
      box-shadow: ${({ theme }) => theme.boxShadows?.focus};
    }

    &:focus:not(&:focus-visible) {
      box-shadow: none;
    }

    &:active:not(:disabled) {
      background: ${({ theme }) => theme.colors.lighter};
    }
  `}

  ${({ reversed }) => reversed && css<StyledButtonProps>`
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme, busy }) => busy ? 'transparent' : theme.colors.primary};
    box-shadow: ${({ theme }) => theme.boxShadows.light};
    font-weight: bold;

    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.colors.primary};
    }

    &[disabled], &:disabled {
      background: ${({ theme }) => theme.colors.disabled};
      font-style: ${({ busy, theme }) => busy ? 'normal' : theme?.Button?.disabledFontStyle};
      cursor: default;
    }

    &:focus-visible, &:focus {
      box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter}, ${({ theme }) => theme?.PrimaryButton?.boxShadow};
    }

    &:focus:not(&:focus-visible) {
      box-shadow: ${({ theme }) => theme?.PrimaryButton?.boxShadow};
    }

    &:active:not(:disabled) {
      color: ${({ theme }) => theme.colors.dark};
    }
  `}

  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
  `}
`;

export const StyledLoaderWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 11px;
  left: 50%;
  margin-left: -14px;
`;

export const StyledLeftMostIcon = styled.svg<{ busy: boolean }>`
  ${media.xs<{ busy: boolean }>`
    position: absolute;
    left:25px;
    top:50%;
    margin-top:-12px;
    visibility: ${({ busy }) => busy ? 'hidden' : 'visible'};
  `}
  ${media.sm<{ busy: boolean }>`
    position: relative;
    left:0px;
    top:6px;
    margin-top:0px;
    margin-right: 12px;
    visibility: ${({ busy }) => busy ? 'hidden' : 'visible'};
   `}
`;

export const StyledLeftIcon = styled.svg<{ busy: boolean }>`
  position: relative;
  top: 6px;
  margin-right: 12px;
  visibility: ${({ busy }) => busy ? 'hidden' : 'visible'};
`;

export const StyledRightIcon = styled.svg<{ busy: boolean }>`
  position: relative;
  top: 6px;
  margin-left: 12px;
  visibility: ${({ busy }) => busy ? 'hidden' : 'visible'};
`;
